// extracted by mini-css-extract-plugin
export default {"menuSection":"MenuOffer_menuSection__TAQcJ","sectionTitle":"MenuOffer_sectionTitle__dbiFW","shinyText":"MenuOffer_shinyText__AXebb"};